import { useQuery } from '@apollo/client';

import { BankTransferRequestDetailDocument } from './bankTransferRequestDetail.gql';

export const useBankTransferRequestDetail = (requestId: string) => {
  const { data, ...hook } = useQuery(BankTransferRequestDetailDocument, {
    notifyOnNetworkStatusChange: true,
    variables: {
      requestId,
    },
  });

  const bankTransferRequest = data?.bankTransferRequest;

  return { bankTransferRequest, ...hook } as const;
};
